import { HTTP, ENDPOINT } from "../config";
import { fetchFromLawfeed } from "../fetchFromLawfeed";

// Eliminar un cliente
export const deleteClient = async (clientId, alsoAccount = "no") => {
    const queryParams = alsoAccount === "yes" ? [{ alsoAccount: "yes" }] : [];

    return await fetchFromLawfeed({
        method: HTTP.DELETE,
        endpoint: ENDPOINT.DELETE_CLIENT.replace(":client", clientId),
        queryParams: queryParams
    });
};
